export const lineColumns = [
  {
    title: '排名',
    dataIndex: 'ranking',
    key: 'ranking',
    scopedSlots: { customRender: 'ranking' },
    width: 120,
  },
  {
    title: '线路名称',
    dataIndex: 'line_name',
    key: 'line_name',
    ellipsis: true,
  },
  {
    title: '订单件数',
    dataIndex: 'order_cnt',
    key: 'order_cnt',
    width: 180,
  },
  {
    title: '占比',
    dataIndex: 'ratio',
    key: 'ratio',
    scopedSlots: { customRender: 'ratio' },
    width: 80,
  },
]
export const goodsColumns = [
  {
    title: '排名',
    dataIndex: 'ranking',
    key: 'ranking',
    scopedSlots: { customRender: 'ranking' },
    width: 120,
  },
  {
    title: '收货门店名称',
    dataIndex: 'station_name',
    key: 'station_name',
    ellipsis: true,
  },
  {
    title: '收货件数',
    dataIndex: 'station_total_num',
    key: 'station_total_num',
    width: 180,
  },
  {
    title: '占比',
    dataIndex: 'ratio',
    key: 'ratio',
    scopedSlots: { customRender: 'ratio' },
    width: 80,
  },
]
export const detailedColumns = [
  {
    title: '排名',
    dataIndex: 'ranking',
    key: 'ranking',
    scopedSlots: { customRender: 'ranking' },
    width: 120,
  },
  {
    title: '货品名称',
    dataIndex: 'sku_name',
    key: 'sku_name',
    ellipsis: true,
  },
  {
    title: '货品件数',
    dataIndex: 'sku_num',
    key: 'sku_num',
    width: 180,
  },
  {
    title: '占比',
    dataIndex: 'ratio',
    key: 'ratio',
    scopedSlots: { customRender: 'ratio' },
    width: 80,
  },
]

export const categoryColumns = [
  {
    title: '排名',
    dataIndex: 'ranking',
    key: 'ranking',
    scopedSlots: { customRender: 'ranking' },
    width: 120,
  },
  {
    title: '品类名称',
    dataIndex: 'sku_name',
    key: 'sku_name',
    ellipsis: true,
  },
  {
    title: '货品件数',
    dataIndex: 'sku_num',
    key: 'sku_num',
    width: 180,
  },
  {
    title: '占比',
    dataIndex: 'ratio',
    key: 'ratio',
    scopedSlots: { customRender: 'ratio' },
    width: 80,
  },
]

export const orderOverViewData = {
  orderCnt: {
    总下单数: 'total_u_order_cnt',
    仓配订单: 'warehouse_delivery_u_order_cnt',
    纯运输: 'transport_u_order_cnt',
    进行中订单数: 'processing_u_order_cnt',
    待派车订单数: 'waiting_dispatch_u_order_cnt',
  },
  orderCntRatio: {
    下单门店数: 'current_period_cnt',
    下单门店数环比: 'ratio'
  },
  transportCost: {
    预估运费: 'current_period_transport_cost',
    预估运费环比: 'ratio',
  },
  signOrder: {
    已签订单数: 'sign_u_order_cnt',
    门店签收次数: 'station_sign_d_oder_cnt',
  }
}

export const abnormalData = {
  计费异常: 'price_exception_num',
  出库异常: 'outbound_exception_num',
  派车超时: 'dispatch_timeout_num',
  取货超时: 'pick_timeout_num',
  签收超时: 'sign_timeout_num',
  温度异常: 'temperature_exception_cnt',
  轨迹预警: 'cargo_warning_num',
}

export const getChartData = () => {
  const processing = []
  const complete = []
  for(let i = 7; i > 0; i-=1) {
    const processingCnt = Math.floor(Math.random()*50);
    const completeCnt = Math.floor(Math.random()*50+100)
    processing.push({
      value: processingCnt,
      total: processingCnt+completeCnt,
      process: processingCnt,
      complete: completeCnt,
    })
    complete.push({
      value: completeCnt,
      total: processingCnt+completeCnt,
      process: processingCnt,
      complete: completeCnt,
    })
  }
  return {
    processing,
    complete
  }
}

export const orderStatisticsData = {
  echartData: [getChartData(),getChartData()],
}

export const transportData = {
  货运: 'huoyun_amt',
  一单一议: 'yidanyiyi_amt',
  点位配: 'dianweipei_amt',
  区域配: 'quyupei_amt',
  零担: 'lingdan_amt',
  专车: 'zhuanche_amt',
}

export const topData = {
  // 线路TOP10
  line: {
    type: 'board_line_top10',
    name: 'line_name',
    val: 'order_cnt'
  },
  // 货品流向TOP10
  goods: {
    type: 'board_goods_stream',
    name: 'station_name',
    val: 'station_total_num',
  },
  // 货品明细运输TOP10
  detailed: {
    type: 'board_goods_transport_top10',
    name: 'sku_name',
    val: 'sku_num',
  },
  // 货品品类运输TOP10
  category: {
    type: 'board_goods_category_trans_top',
    name: 'sku_name',
    val: 'sku_num',
  }
}